
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/arrow-right","xmlns":"http://www.w3.org/2000/svg","width":"19.686","height":"19.686","viewBox":"0 0 19.686 19.686"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#484f5b","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M2.871 9.843h13.8"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.773 2.941v13.8"}})])])
          )
        }
      }
    